module.exports = __webpack_public_path__ + "img/chenggong.6fa6d22b.svg";